<template>
  <div class="comp-job">
    <div class="head">
      <div class="left">
        <router-link :to="`${$subsitePrefix}/ah/job/detail/${data.Id}`" :target="target">{{ data.PostName }}</router-link>
      </div>
      <div class="right">{{ data.Enterprise }}</div>
    </div>
    <div class="body">
      <div class="left">
        <strong>{{ data.Salary }}</strong>
        <span>{{ data.Workplace || "--" }}</span>
        <span>{{ data.Education }}</span>
        <span>{{ data.HiringCount }}人</span>
      </div>
      <div class="right">
        <!-- <span>{{ data.industry }}</span>
        <span>{{ data.type }}</span>
        <span>{{ data.size }}</span> -->
      </div>
    </div>
    <div class="foot">
      <div class="left">
        <span v-for="(item, i) in data.tags" :key="i">{{ item }}</span>
      </div>
      <div class="right">
        <span class="date">{{ data.date }}</span>
        <div class="btn">
          <a class="chat" href="/admin/">在线沟通</a>
          <a class="send" href="/admin/">投递简历</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "job-card",
  props: {
    data: {
      type: Object
    },
    target: {
      type: String,
      default: "_self"
    }
  }
};
</script>

<style lang="scss" scoped>
.comp-job {
  .head,
  .body,
  .foot {
    display: flex;
    justify-content: space-between;
    padding-bottom: 16px;
  }
  .head {
    font-size: 20px;
  }
  .body {
    font-size: 14px;
    span {
      position: relative;
      padding-left: 10px;
      margin-left: 10px;
      &::before {
        width: 1px;
        height: 12px;
        background-color: #ccc;
        position: absolute;
        left: 0;
        top: 1px;
        content: ' ';
      }
    }
    .left {
      color: #666;
      strong {
        color: #ff6010;
        font-weight: 500;
        font-size: 20px;
      }
    }
    .right {
      color: #999;
      span:first-child {
        &::before {
          display: none;
        }
      }
    }
  }
  .foot {
    .left {
      color: #999;
      font-size: 12px;
      span {
        background: rgba(252, 252, 252, 1);
        border-radius: 4px;
        border: 1px solid rgba(221, 221, 221, 1);
        padding: 2px 4px;
        margin-right: 8px;
      }
    }
    .right {
      color: #ccc;
    }
  }
  .btn {
    display: none;
    position: absolute;
    right: 0;
    bottom: 5px;
    background-color: #fff;
    padding: 10px 0;
    a {
      width: 88px;
      height: 32px;
      border-radius: 20px;
      border: 1px solid $primary-color;
      color: $primary-color;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      margin-left: 8px;
      &.send {
        color: #fff;
        background-color: $primary-color;
      }
    }
  }
  border-bottom: 1px solid #eee;
  padding: 20px 0 10px 0;
  position: relative;
  &:hover {
    .btn {
      display: block;
    }
  }
}
</style>
